import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  class: "grid",
  ref: "gridContainer"
}
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "col md:col-6" }
const _hoisted_6 = { class: "col md:col-6" }
const _hoisted_7 = {
  key: 0,
  class: "col pt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormQuestions = _resolveComponent("FormQuestions")!
  const _component_NewFormElement = _resolveComponent("NewFormElement")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormQuestions, {
              formQuestions: _ctx.formQuestions,
              userResponses: {},
              editMode: true,
              onChangeOrder: _ctx.handleChangeOrder,
              onResize: _ctx.handleResize,
              onEdit: _ctx.handleEdit,
              onRemove: _ctx.handleQuickDelete
            }, null, 8, ["formQuestions", "onChangeOrder", "onResize", "onEdit", "onRemove"]),
            _createElementVNode("div", {
              class: "col add-form-element",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
                _ctx.showModal = true;
                _ctx.resetNewFormQuestion();
              })
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("p", null, [
                _createElementVNode("span", { class: "add-sign" }, "+"),
                _createTextVNode(" Add New Form Field")
              ], -1)
            ]))])
          ], 512),
          _createVNode(_component_Modal, {
            modelValue: _ctx.showModal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
            title: 
              _ctx.editingFormQuestion
                ? 'form.fields.edit-field'
                : 'form.fields.new-field'
            ,
            onCancel: _ctx.handleCancel,
            onConfirm: _ctx.handleSaveFormQuestion,
            onRemove: _ctx.handleDeleteFormQuestion,
            onDismiss: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NewFormElement, {
                editing: _ctx.editingFormQuestion,
                modelValue: _ctx.newFormQuestion,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newFormQuestion) = $event)),
                formQuestions: _ctx.formQuestions,
                onAddChoice: _ctx.handleAddNewChoice,
                onChangeQuestionType: _ctx.handleChangeQuestionType
              }, null, 8, ["editing", "modelValue", "formQuestions", "onAddChoice", "onChangeQuestionType"])
            ]),
            footer: _withCtx(({ confirm, cancel, remove }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    text: "common.cancel",
                    onClick: cancel,
                    class: "w-100",
                    variant: "secondary"
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    class: "w-100",
                    text: "common.save",
                    onClick: confirm,
                    disabled: false
                  }, null, 8, ["onClick"])
                ]),
                (_ctx.editingFormQuestion)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_Button, {
                        class: "w-100",
                        text: "common.delete",
                        onClick: remove,
                        disabled: false,
                        variant: "error-link"
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "title", "onCancel", "onConfirm", "onRemove", "onDismiss"])
        ])
      ])
    ])
  ]))
}